import styled from "styled-components";

export const Category = styled.div`
    background-color: #E46474;
    min-height: 12.625rem;
    border-radius: .5rem;
    max-width: 12.5rem;
    margin:0 auto;
`
export const Info = styled.div`
    padding: 1rem;
`
export const CatName = styled.h2`
    font-size: 2.5rem;
    color: #872F3A;
    font-weight: 500;
`
export const LinkFollow = styled.a`
    text-decoration: underline;
    font-size: 1rem;
    font-weight: 500;
    color: #872f3a;
    cursor: pointer;
`
export const CatImg = styled.img`
    position: absolute;
    margin-left: 3rem;
    max-width: 9.625rem;
    width: 100%;
`